module.exports = __webpack_public_path__ + "img/V96.243376e6.jpg";